import { combineReducers } from 'redux';
import {
  LIBRARY_PROMO_CLOSE_RIGHT_COLUMN,
  LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_OPEN_RIGHT_COLUMN,
  LIBRARY_PROMO_SET_ACCORDION_ACTIVE_KEY,
  LIBRARY_PROMO_SET_CURRENT_PAGE,
  LIBRARY_PROMO_SET_DETAIL_PROMO,
  LIBRARY_PROMO_SET_INTERSECT_CATEGORIES,
  LIBRARY_PROMO_SET_INTERSECT_ITEMS,
  LIBRARY_PROMO_SET_INTERSECT_VARIANTS,
  LIBRARY_PROMO_SET_IS_SUBMITTED_EACH_PROMO_FORM,
  LIBRARY_PROMO_SET_IS_SUBMITTING_FORM,
  LIBRARY_PROMO_SET_LIST_PROMO,
  LIBRARY_PROMO_SET_OUTLETS,
  LIBRARY_PROMO_SET_PROMO_TYPES,
  LIBRARY_PROMO_SET_SELECTED_OUTLETS,
  LIBRARY_PROMO_SET_TOTAL_PAGE,
  LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_SET_DELETED_PROMO,
  LIBRARY_PROMO_SHOW_DELETE_MODAL,
  LIBRARY_PROMO_HIDE_DELETE_MODAL,
  LIBRARY_PROMO_SET_DEACTIVATED_PROMO,
  LIBRARY_PROMO_SHOW_DEACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_DEACTIVATE_MODAL,
  LIBRARY_PROMO_SET_REACTIVATED_PROMO,
  LIBRARY_PROMO_SHOW_REACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_REACTIVATE_MODAL,
  LIBRARY_PROMO_SHOW_CONFIRM_REACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_CONFIRM_REACTIVATE_MODAL,
  LIBRARY_PROMO_SET_PREV_ASSIGNED_OUTLETS,
  LIBRARY_PROMO_SHOW_UPDATE_CONFIRM_MODAL,
  LIBRARY_PROMO_HIDE_UPDATE_CONFIRM_MODAL,
  LIBRARY_PROMO_SET_NEXT_UPDATE_ACTION,
  LIBRARY_PROMO_SET_ACTION_UPDATE_NAME,
} from 'actions/businessLibrary/promo/constants';

import createReducer from 'utils/createReducer';

const actionUpdateName = createReducer('', {
  [LIBRARY_PROMO_SET_ACTION_UPDATE_NAME]: (draft, { payload }) =>
    payload.actionUpdateName,
});

const activeAccordion = createReducer('1', {
  [LIBRARY_PROMO_SET_ACCORDION_ACTIVE_KEY]: (draft, { payload }) =>
    String(payload.activeKey),
});

const categories = createReducer([], {
  [LIBRARY_PROMO_SET_INTERSECT_CATEGORIES]: (draft, { payload }) =>
    payload.categories,
});

const currentPage = createReducer(null, {
  [LIBRARY_PROMO_SET_CURRENT_PAGE]: (draft, { payload }) => payload.currentPage,
});

const deactivatedPromo = createReducer(null, {
  [LIBRARY_PROMO_SET_DEACTIVATED_PROMO]: (draft, { payload }) =>
    payload.deactivatedPromo,
});

const deletedPromo = createReducer(null, {
  [LIBRARY_PROMO_SET_DELETED_PROMO]: (draft, { payload }) =>
    payload.deletedPromo,
});

const detailPromo = createReducer(null, {
  [LIBRARY_PROMO_SET_DETAIL_PROMO]: (draft, { payload }) => payload.detailPromo,
});

const isSubmitPromoForm = createReducer(
  {},
  {
    [LIBRARY_PROMO_SET_IS_SUBMITTED_EACH_PROMO_FORM]: (draft, { payload }) =>
      payload.newPromoForm,
  }
);

const isSubmittingForm = createReducer(false, {
  [LIBRARY_PROMO_SET_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmit,
});

const items = createReducer([], {
  [LIBRARY_PROMO_SET_INTERSECT_ITEMS]: (draft, { payload }) => payload.items,
});

const nextUpdateAction = createReducer(null, {
  [LIBRARY_PROMO_SET_NEXT_UPDATE_ACTION]: (draft, { payload }) =>
    payload.nextUpdateAction,
});

const openRightColumn = createReducer(false, {
  [LIBRARY_PROMO_OPEN_RIGHT_COLUMN]: () => true,
  [LIBRARY_PROMO_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  [LIBRARY_PROMO_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const previousAssignedOutlets = createReducer(null, {
  [LIBRARY_PROMO_SET_PREV_ASSIGNED_OUTLETS]: (draft, { payload }) =>
    payload.prevAssignedOutlet,
});

const promos = createReducer([], {
  [LIBRARY_PROMO_SET_LIST_PROMO]: (draft, { payload }) => payload.promos,
});

const promoTypes = createReducer([], {
  [LIBRARY_PROMO_SET_PROMO_TYPES]: (draft, { payload }) => payload.promoTypes,
});

const reactivatedPromo = createReducer(null, {
  [LIBRARY_PROMO_SET_REACTIVATED_PROMO]: (draft, { payload }) =>
    payload.reactivatedPromo,
});

const selectedOutlets = createReducer([], {
  [LIBRARY_PROMO_SET_SELECTED_OUTLETS]: (draft, { payload }) =>
    payload.selectedOutlets,
});

const showAssignOutletModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_MODAL]: () => false,
});

const showConfirmReactivateModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_CONFIRM_REACTIVATE_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_CONFIRM_REACTIVATE_MODAL]: () => false,
});

const showDeactivateModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_DEACTIVATE_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_DEACTIVATE_MODAL]: () => false,
});

const showDeleteModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_DELETE_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_DELETE_MODAL]: () => false,
});

const showReactivateModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_REACTIVATE_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_REACTIVATE_MODAL]: () => false,
});

const showUpdateConfirmModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_UPDATE_CONFIRM_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_UPDATE_CONFIRM_MODAL]: () => false,
});

const totalPage = createReducer(null, {
  [LIBRARY_PROMO_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

const variants = createReducer(
  {},
  {
    [LIBRARY_PROMO_SET_INTERSECT_VARIANTS]: (draft, { payload }) =>
      payload.variants,
  }
);

export default combineReducers({
  actionUpdateName,
  activeAccordion,
  categories,
  currentPage,
  deactivatedPromo,
  deletedPromo,
  detailPromo,
  isSubmitPromoForm,
  isSubmittingForm,
  items,
  nextUpdateAction,
  openRightColumn,
  outlets,
  previousAssignedOutlets,
  promos,
  promoTypes,
  reactivatedPromo,
  selectedOutlets,
  showAssignOutletModal,
  showConfirmReactivateModal,
  showDeactivateModal,
  showDeleteModal,
  showReactivateModal,
  showUpdateConfirmModal,
  totalPage,
  variants,
});
